import { Component, ErrorInfo, ReactNode } from 'react';
import styles from './ErrorBoundary.module.css';

interface ErrorBoundaryProps {
    children: ReactNode;
}

interface ErrorBoundaryState {
    error: Error | null;
}

/**
 * Atrapa errores de render de una sección para que no deje toda la web en blanco.
 * Usar con `key` (ej: la ruta actual) para que se reinicie al navegar a otra sección.
 */
export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    state: ErrorBoundaryState = { error: null };

    static getDerivedStateFromError(error: Error): ErrorBoundaryState {
        return { error };
    }

    componentDidCatch(error: Error, info: ErrorInfo) {
        console.error('Error de render en sección del dashboard:', error, info.componentStack);
    }

    handleRetry = () => {
        this.setState({ error: null });
    };

    render() {
        if (!this.state.error) return this.props.children;

        return (
            <div className={styles.container}>
                <div className={styles.card}>
                    <h2 className={styles.title}>Esta sección tuvo un problema</h2>
                    <p className={styles.message}>
                        Ocurrió un error al mostrar esta página. Puedes reintentar o ir a otra sección desde el menú.
                    </p>
                    <pre className={styles.detail}>{this.state.error.message}</pre>
                    <button className={styles.retryButton} onClick={this.handleRetry}>
                        Reintentar
                    </button>
                </div>
            </div>
        );
    }
}
